// src/pages/Main.tsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "../auth/AuthProvider";
import { SocketProvider, useSocket } from "../context/SocketProvider";
import AreaSiteGroupSelector from "../components/AreaSiteGroupSelector";
import GroupSettings from "../components/GroupSettings";
import DeviceSettings from "../components/DeviceSettings";
import GroupStatus from "../components/GroupStatus";

import UserInfoDrawer from "../components/UserInfoDrawer";

import { MediaQuery } from 'react-responsive';
import * as Style from "../styles/Main.style";

// Tablet Images
import ImgMenu from '../imgs/Group4.svg';
import ImgMainLogo from '../imgs/ic_main_logo_tablet.svg';
import ImgLogo from '../imgs/REK.svg';
import ImgLogoText1 from '../imgs/ic_logo_text1_tablet.svg';
import ImgLogoText2 from '../imgs/ic_logo_text2_tablet.svg';

// Mobile Images
import Img_M_Symbol from '../imgs/mobile/ic_mobile_symbol.svg';
import Img_M_Logo from '../imgs/mobile/ic_mobile_logo.svg';

//const SOCKET_URL = "http://172.16.20.112:3000"; // socket.io 서버
//const SOCKET_URL = process.env.SOCKET_URL2 || 'localhost:3000';
const SOCKET_URL = "https://rek-hybrid.co.kr"; // socket.io 서버


type MSlot = { time: number; bright: number; is_active: boolean };
const MainContent: React.FC = () => {

    const backgroundRef = React.useRef<HTMLDivElement>(null); // Ref 생성

    /******************* 변수 *******************/
    const { user } = useAuth();
    const socket = useSocket();

    // 지역 선택 정보
    const [areas, setAreas] = useState<any[]>([]);
    const [selectedAreaId, setSelectedAreaId] = useState<number | null>(null);
    const [selectedSiteId, setSelectedSiteId] = useState<number | null>(null);
    const [selectedGroupId, setSelectedGroupId] = useState<number | null>(null);

    const [selectedGroupName, setSelectedGroupName] = useState<string | null>('');  

    const [devices, setDevices] = useState< any[]>([]);
    const [currentIndex, setCurrentIndex] = useState(0);

    /**
     * 그룹, 디바이스 탭 및 각 탭 내부 탭 설정 값
     */
    // 그룹, 디바이스 탭
    // const [activeGroup_DeviceTab, setActiveGroup_DeviceTab] = useState<"group" | "device">("device");
    const [activeGroup_DeviceTab, setActiveGroup_DeviceTab] = useState<"group" | "device" | "status">("status");
    // 디바이스 탭
    const [deviceSettingTab, setDeviceSettingTab] = useState<number>(1);

    // 디바이스 탭 제어 1 탭 설정 값
    const [this_brightness, setThisBrightness] = useState<number>(80);
    const [this_brightnessMode, setThisBrightnessMode] = useState<number>(1); // 기본 선택

    // 디바이스 탭 제어 2 탭 설정 값 없음

    // 디바이스 탭 제어 3 탭 설정 값
    const [this_distanceLeft, setThisDistanceLeft] = useState<number>(1);
    const [this_distanceRight, setThisDistanceRight] = useState<number>(1);
    const [this_distanceBottom, setThisDistanceBottom] = useState<number>(1);

    // 디바이스 탭 그래프
    // 그래프 데이터
    const [tempData, setTempData] = useState<any[]>([]);
    const [humidData, setHumidData] = useState<any[]>([]);
    

    // 그룹 탭 내 설정 탭
    const [groupSettingTab, setGroupSettingTab] = useState<number>(1);
    // 그룹 탭 제어 1 탭 설정 값
    const [brightness, setBrightness] = useState<number>(80);
    const [brightnessMode, setBrightnessMode] = useState<number>(1);

    // 그룹 탭 제어 2 탭 설정 값 없음

    // 그룹 탭 제어 3 탭 설정 값
    const [distanceLeft, setDistanceLeft] = useState<number>(1);
    const [distanceRight, setDistanceRight] = useState<number>(1);
    const [distanceBottom, setDistanceBottom] = useState<number>(1);

    // 그룹 탭 제어 4 탭 설정 값
    const [led_mode, setLed_mode] = useState<number>(0);
    const [maxBright, setMaxBright] = useState<number>(1);
    const [minBright, setMinBright] = useState<number>(1);
    const [keepOnTime, setKeepOnTime] = useState<number>(1);
    const [sideOnLed, setSideOnLed] = useState<number>(1);


    // 그룹 탭 제어 5 탭 월별 시간 밝기 값
    // 월별 설정 탭 상태 (1부터 12) 추가
    const [activeMonthTab, setActiveMonthTab] = useState<number>(1);
    const [nowMonth, setnowMonth] = useState<number>(1);
    const [mValues, setMValues] = useState<Record<string, MSlot[]>>({});



    /******************* useEffect *******************/

    // ✅ DB에서 area/site/group 불러오기
    useEffect(() => {
        if (!user) return;
        const fetchAreas = async () => {
            try {
                const res = await axios.get<any[]>(`${SOCKET_URL}/api/user/${user.id}/areas`); // 예시: NestJS 컨트롤러에서 제공
                setAreas(res.data);
            } catch (err) {
                console.error("❌ Area 데이터 로드 실패", err);
            }
        };
        fetchAreas();
    }, [user]);

    // ✅ site, group 선택 시 소켓 subscribe
    useEffect(() => {
        if (!socket || !selectedSiteId || !selectedGroupId) return;

        // const sid: string = formatpaddedId(selectedSiteId,4);
        // const gid: string = formatpaddedId(selectedGroupId,3);      

        // const topic = `${sid}/${gid}/sts`;   
        const topic = `${selectedSiteId}/${selectedGroupId}/sts`;
        socket.emit("subscribe", { 
            siteId: selectedSiteId, 
            groupId: selectedGroupId
         });
        // 데이터 초기화
        setDevices([]);
        setCurrentIndex(0);

        // 지역 바뀔때 마다 mType2,4에 대한 정보 1회 요청
        // handleApply_Gets(2);
        // handleApply_Gets(4);
        fetchDeviceInfo();
        
        setActiveGroup_DeviceTab("status");

        //console.log("📡 MQTT Subscribe:", topic);

        return () => {
            socket.emit("unsubscribe", { siteId: selectedSiteId, groupId: selectedGroupId });
            //console.log("📴 MQTT Unsubscribe:", topic);
        };
    }, [socket, selectedSiteId, selectedGroupId]);

    // ✅ mqtt-data 수신
    useEffect(() => {
        if (!socket) return;
        const handler = (payload: any) => {
            if (payload && Array.isArray(payload.data)) {
                setDevices(payload.data);
                setCurrentIndex((prev) =>
                    prev >= payload.data.length ? (payload.data.length > 0 ? payload.data.length - 1 : 0) : prev
                );
            }
        };
        socket.on("mqtt-data", handler);
        return () => {
            socket.off("mqtt-data", handler);
        };
    }, [socket]);

    // ✅ Socket.IO 재연결 시 구독 상태 복원
    // 'connect' 이벤트는 최초 연결 및 재연결 성공 시 모두 발생
    useEffect(() => {
        if (!socket) return;

        const handleSocketConnect = () => {
            //console.log("🌐 Socket Connected/Reconnected. Checking subscription state...");
            
            // 현재 선택된 siteId와 groupId가 유효한지 확인합니다.
            if (selectedSiteId && selectedGroupId) {
                // 서버의 'subscribe' 이벤트에 이전에 구독했던 SiteId와 GroupId를 다시 전송하여
                // MQTT 구독을 복원 요청합니다.
                socket.emit("subscribe", { 
                    siteId: selectedSiteId, 
                    groupId: selectedGroupId
                });
                const topic = `${selectedSiteId}/${selectedGroupId}/sts`;
                //console.log("🔄 Resubscribing to MQTT topic:", topic);
            }
        };

        // 'connect' 이벤트 리스너 등록
        socket.on('connect', handleSocketConnect);

        return () => {
            // 컴포넌트 언마운트 시 리스너 해제
            socket.off('connect', handleSocketConnect);
        };
    // selectedSiteId와 selectedGroupId가 변경될 때마다 최신 값을 사용하도록 핸들러를 갱신
    }, [socket, selectedSiteId, selectedGroupId]);    

    /******************* 일반 함수 *******************/

    const formatpaddedId = (num: number, targetLength: number): string => {
        // 1. 숫자를 문자열로 변환합니다.
        const str = String(num);
        // 2. padStart() 메서드를 사용하여 문자열의 시작 부분을 '0'으로 채웁니다.
        return str.padStart(targetLength, '0');
    }

    // 그룹 디바이스 정보 요청에 대한 pub
    const handleApply_Gets = (req : number) => {
        if (!socket || !selectedSiteId || !selectedGroupId) return;

        const sid: string = formatpaddedId(selectedSiteId,4);
        const gid: string = formatpaddedId(selectedGroupId,3);

        let payload: any = { siteId: sid, groupId: gid };	        
        // let payload: any = { siteId: selectedSiteId, groupId: selectedGroupId };

        payload = {
            ...payload,
            req,
        };

        socket.emit('get_publish', payload);
        //alert(`전송 데이터: ${JSON.stringify(payload, null, 2)}`);
    };

    // 초기 디바이스 정보 조회
    const fetchDeviceInfo = async () => {
        try {
            const response = await axios.get(`${SOCKET_URL}/api/device/info`, {
            params: { selectedSiteId, selectedGroupId },
            });
            //const response = await axios.post(`${SOCKET_URL}/device/info`, { selectedSiteId, selectedGroupId, deviceId });
            if(response.data === null || response.data === '')
            {
                console.log('[DEBUG] React: 조회 값 없음');
                //setDevices();
            }
            else
            {
                //console.log('[DEBUG] React: 조회 응답', response.data);
                setDevices(response.data.data);
            }
        } catch (error) {
            console.error('[DEBUG] React: API 호출 실패', error);
        }
    };    


    const DEVICES_ON_SCREEN = 3;
    // ... (state 및 devices 데이터)

    // 최대 허용 시작 인덱스
    const maxStartIndex = devices.length > DEVICES_ON_SCREEN ? devices.length - DEVICES_ON_SCREEN : 0;

    const nextDevice = () => {
        // 1. currentIndex를 1 증가
        let newIndex = currentIndex + DEVICES_ON_SCREEN;

        // 2. 최대 허용 시작 인덱스를 넘어서면, 그 값으로 고정
        if (newIndex > maxStartIndex) {
            newIndex = maxStartIndex;
        }
        
        // 3. 업데이트
        if (currentIndex < maxStartIndex) { // 마지막 그룹 시작 전까지만 실제로 1씩 이동
            setCurrentIndex(newIndex);
        }
        // currentIndex가 이미 maxStartIndex인 경우, nextDevice를 눌러도 이동하지 않음 (버튼이 disabled될 것임)
    };

    const prevDevice = () => {
        // 1. currentIndex를 1 감소
        let newIndex = currentIndex - DEVICES_ON_SCREEN;

        // 2. 0보다 작으면 0으로 고정
        if (newIndex < 0) {
            newIndex = 0;
        }
        
        // 3. 업데이트
        setCurrentIndex(newIndex);
    };    

    // 디바이스 페이지 이동
    // const nextDevice = () => {
    //     if (currentIndex < devices.length - 1) setCurrentIndex(currentIndex + 1);
    // };
    // const prevDevice = () => {
    //     if (currentIndex > 0) setCurrentIndex(currentIndex - 1);
    // };

    // 페이지 새로고침을 수행하는 함수
    const handleReload = () => {
        // 실제 페이지 새로고침을 강제합니다.
        window.location.reload(); 
        // console.log('페이지 새로고침 실행됨');
    };

    /******************************************************************/
    /************************ 메인 배치 레이아웃 ***********************/
    /******************************************************************/    

    // 👇 모션 모드 선택 모달 표시 여부 상태 추가
    const [isUserInfoModalOpen, setIsUserInfoModalOpen] = useState(false);
    // 👇 모션 모드 모달 열기/닫기 핸들러
    const openUserInfoModal = () => setIsUserInfoModalOpen(true);
    const closeUserInfoModal = () => setIsUserInfoModalOpen(false);

    /******************* UI *******************/


    return (
        <>
        <MediaQuery maxWidth={767}>
            <Style.BackgroundArea ref={backgroundRef}>

                <Style.NavFrame>
                    <Style.NavInFrame
                        onClick={handleReload}
                    >
                        <Style.NavImgContainer>
                            <Style.NavMainLogo
                                $logoUrl={Img_M_Symbol}
                            />
                            <Style.NavSubLogo
                                $logoUrl={Img_M_Logo}
                            />
                        </Style.NavImgContainer>
                    </Style.NavInFrame>
                    <Style.NavMenu
                        onClick={openUserInfoModal}
                        $imgUrl={ImgMenu}
                    >
                    </Style.NavMenu>
                </Style.NavFrame>

                <Style.MenuTabContainer>
                {/* ✅ 지역/사이트/그룹 선택 */}
                <Style.SelectorBoxFrame>
                    <AreaSiteGroupSelector
                        backgroundRef={backgroundRef}
                        areas={areas}
                        selectedAreaId={selectedAreaId}
                        selectedSiteId={selectedSiteId}
                        selectedGroupId={selectedGroupId}

                        onAreaChange={(id) => {
                            setSelectedAreaId(id);
                        }}
                        onSiteChange={(id) => {
                            setSelectedSiteId(id);
                        }}
                        onGroupChange={(id) => {
                            setSelectedGroupId(id);
                        }}
                        onGroupNameChange={(name) => {
                            setSelectedGroupName(name);
                        }}
                    />
                </Style.SelectorBoxFrame>
                {/* ✅ 지역/사이트/그룹 선택 끝 */}

                {/* ✅ 그룹, 디바이스 탭 */}
                {(selectedSiteId && selectedGroupId) && (
                    <Style.TabFrame>
                    <>
                        {/* ✨ 새로 추가된 status 탭 ✨ */}
                        {activeGroup_DeviceTab === "status" ? (
                            <Style.TabFocus onClick={() => setActiveGroup_DeviceTab("status")}>
                                그룹 상태
                                <Style.TabFocusLine />
                            </Style.TabFocus>
                        ) : (
                            <Style.TabUnFocus onClick={() => setActiveGroup_DeviceTab("status")}>
                                그룹 상태
                            </Style.TabUnFocus>
                        )}
                        {/* 그룹 제어 탭 */}
                        {activeGroup_DeviceTab === "group" ? (
                            <Style.TabFocus onClick={() => setActiveGroup_DeviceTab("group")}>
                                그룹 제어
                                <Style.TabFocusLine />
                            </Style.TabFocus>
                        ) : (
                            <Style.TabUnFocus onClick={() => setActiveGroup_DeviceTab("group")}>
                                그룹 제어
                            </Style.TabUnFocus>
                        )}

                        {/* 개별 제어 탭 */}
                        {activeGroup_DeviceTab === "device" ? (
                            <Style.TabFocus onClick={() => setActiveGroup_DeviceTab("device")}>
                                개별 상태/제어
                                <Style.TabFocusLine />
                            </Style.TabFocus>
                        ) : (
                            <Style.TabUnFocus onClick={() => setActiveGroup_DeviceTab("device")}>
                                개별 상태/제어
                            </Style.TabUnFocus>
                        )}
                    </>

                    </Style.TabFrame>
                )}
                {/* ✅ 그룹, 디바이스 탭 끝 */}

                {/* ✅ 메뉴 탭 */}
                <Style.MenuArea>
                    {!selectedSiteId || !selectedGroupId ? (
                        <>
                        </>
                    ) : activeGroup_DeviceTab === "group" ? (
                    <GroupSettings
                        onfetchDeviceInfo={fetchDeviceInfo}
                        // user 정보
                        currentUser={user}
                        devices={devices}            
                        // 탭 위치
                        groupSettingTab={groupSettingTab}
                        setGroupSettingTab={setGroupSettingTab}
                        // site id, group id
                        selectedSiteId={selectedSiteId}
                        selectedGroupId={selectedGroupId}
                        // Tab 1
                        brightness={brightness}
                        setBrightness={setBrightness}
                        brightnessMode={brightnessMode}
                        setBrightnessMode={setBrightnessMode}
                        // Tab 2
                        // 설정 값 없음
                        // Tab 3
                        distanceLeft={distanceLeft}
                        setDistanceLeft={setDistanceLeft}
                        distanceRight={distanceRight}
                        setDistanceRight={setDistanceRight}
                        distanceBottom={distanceBottom}
                        setDistanceBottom={setDistanceBottom}
                        // Tab 4
                        led_mode={led_mode}
                        setLed_mode={setLed_mode}
                        maxBright={maxBright}
                        setMaxBright={setMaxBright}
                        minBright={minBright}
                        setMinBright={setMinBright}
                        keepOnTime={keepOnTime}
                        setKeepOnTime={setKeepOnTime}
                        sideOnLed={sideOnLed}
                        setSideOnLed={setSideOnLed}
                        // Tab 5
                        activeMonthTab={activeMonthTab}
                        setActiveMonthTab={setActiveMonthTab}
                        nowMonth={nowMonth}
                        setnowMonth={setnowMonth}
                        mValues={mValues}
                        setMValues={setMValues}
                        />
                    ) : activeGroup_DeviceTab === "device" ? (
                    <DeviceSettings
                        // user 정보
                        currentUser={user}
                        devices={devices}
                        currentIndex={currentIndex}
                        setCurrentIndex={setCurrentIndex}
                        nextDevice={nextDevice}
                        prevDevice={prevDevice}
                        selectedSiteId={selectedSiteId}
                        selectedGroupId={selectedGroupId}
                        selectedGroupName={selectedGroupName}

                        deviceSettingTab={deviceSettingTab}
                        setDeviceSettingTab={setDeviceSettingTab}

                        // 디바이스 탭 제어 1 탭 설정 값
                        this_brightness={this_brightness}
                        setThisBrightness={setThisBrightness}
                        this_brightnessMode={this_brightnessMode}
                        setThisBrightnessMode={setThisBrightnessMode}

                        // 디바이스 탭 제어 2 탭 설정 값 없음

                        // 디바이스 탭 제어 3 탭 설정 값
                        this_distanceLeft={this_distanceLeft}
                        setThisDistanceLeft={setThisDistanceLeft}
                        this_distanceRight={this_distanceRight}
                        setThisDistanceRight={setThisDistanceRight}
                        this_distanceBottom={this_distanceBottom}
                        setThisDistanceBottom={setThisDistanceBottom}

                        // 디바이스 탭 제어 4 탭 설정 값
                        led_mode={led_mode}
                        setLed_mode={setLed_mode}
                        maxBright={maxBright}
                        setMaxBright={setMaxBright}
                        minBright={minBright}
                        setMinBright={setMinBright}
                        keepOnTime={keepOnTime}
                        setKeepOnTime={setKeepOnTime}
                        sideOnLed={sideOnLed}
                        setSideOnLed={setSideOnLed}
                        
                        // 그래프
                        tempData={tempData}
                        setTempData={setTempData}
                        humidData={humidData}
                        setHumidData={setHumidData}

                        />
                    ) : (
                    <GroupStatus
                        // user 정보
                        currentUser={user}
                        devices={devices}
                        selectedSiteId={selectedSiteId}
                        selectedGroupId={selectedGroupId}
                        selectedGroupName={selectedGroupName}

                        />                        
                    )}
                </Style.MenuArea>
                {/* ✅ 메뉴 탭 끝 */}
                <br></br>
                </Style.MenuTabContainer>
                <>
                {/* 👇 계정 프로필 모달 컴포넌트 렌더링 */}
                {isUserInfoModalOpen && (
                    <UserInfoDrawer
                        isOpen={isUserInfoModalOpen}
                        currentUser={user}
                        onClose={closeUserInfoModal}
                    />
                )}
                </>

            </Style.BackgroundArea>
        </MediaQuery>

{/* ////////////////////////////////////////////////////////////////////////////// */}
{/* ////////////////////////////////////////////////////////////////////////////// */}
{/* ////////////////////////////////////////////////////////////////////////////// */}
{/* ////////////////////////////////////////////////////////////////////////////// */}
{/* ////////////////////////////////////////////////////////////////////////////// */}
{/* **************************** 태블릿, 데스트톱 UI ****************************** */}

        <MediaQuery minWidth={768}>
            <Style.BackgroundArea ref={backgroundRef}>

                <Style.NavLogoFrame
                    onClick={handleReload}
                >

                    <Style.NavMainLogo
                        $logoUrl={ImgMainLogo}
                        >
                    </Style.NavMainLogo>
                    <Style.NavInFrame>
                        <Style.NavSubLogo
                            $logoUrl={ImgLogo}
                            >
                        </Style.NavSubLogo>

                        <Style.NavTextContainer>
                        <Style.NavSubLogoText1
                            $logoUrl={ImgLogoText1}
                        >
                        </Style.NavSubLogoText1>
                        <Style.NavSubLogoText2
                            $logoUrl={ImgLogoText2}
                        >
                        </Style.NavSubLogoText2>
                        </Style.NavTextContainer>
                    </Style.NavInFrame>

                </Style.NavLogoFrame>

                {/* ✅ 지역/사이트/그룹 선택 */}
                <Style.SelectorBoxFrame>
                    <AreaSiteGroupSelector
                        backgroundRef={backgroundRef}
                        areas={areas}
                        selectedAreaId={selectedAreaId}
                        selectedSiteId={selectedSiteId}
                        selectedGroupId={selectedGroupId}

                        onAreaChange={(id) => {
                            setSelectedAreaId(id);
                        }}
                        onSiteChange={(id) => {
                            setSelectedSiteId(id);
                        }}
                        onGroupChange={(id) => {
                            setSelectedGroupId(id);
                        }}
                        onGroupNameChange={(name) => {
                            setSelectedGroupName(name);
                        }}                    
                    />
                </Style.SelectorBoxFrame>
                {/* ✅ 지역/사이트/그룹 선택 끝 */}

                {/* ✅ 계정 프로필 아이콘 영역 */}
                <Style.NavMenuFrame
                    onClick={openUserInfoModal}
                >
                    <Style.NavMenu
                        $imgUrl={ImgMenu}
                    >
                    </Style.NavMenu>
                    <Style.NavMenuText>
                        {user?.name}
                    </Style.NavMenuText>
                </Style.NavMenuFrame>
                {/* ✅ 계정 프로필 아이콘 영역 끝 */}

                {/* ✅ 그룹, 디바이스 탭 */}
                {(selectedSiteId && selectedGroupId) && (
                    <Style.TabFrame>
                    <>
                        {/* ✨ 새로 추가된 status 탭 ✨ */}
                        {activeGroup_DeviceTab === "status" ? (
                            <Style.TabFocus onClick={() => setActiveGroup_DeviceTab("status")}>
                                그룹 상태
                                <Style.TabFocusLine />
                            </Style.TabFocus>
                        ) : (
                            <Style.TabUnFocus onClick={() => setActiveGroup_DeviceTab("status")}>
                                그룹 상태
                            </Style.TabUnFocus>
                        )}
                        {/* 그룹 제어 탭 */}
                        {activeGroup_DeviceTab === "group" ? (
                            <Style.TabFocus onClick={() => setActiveGroup_DeviceTab("group")}>
                                그룹 제어
                                <Style.TabFocusLine />
                            </Style.TabFocus>
                        ) : (
                            <Style.TabUnFocus onClick={() => setActiveGroup_DeviceTab("group")}>
                                그룹 제어
                            </Style.TabUnFocus>
                        )}

                        {/* 개별 제어 탭 */}
                        {activeGroup_DeviceTab === "device" ? (
                            <Style.TabFocus onClick={() => setActiveGroup_DeviceTab("device")}>
                                개별 상태/제어
                                <Style.TabFocusLine />
                            </Style.TabFocus>
                        ) : (
                            <Style.TabUnFocus onClick={() => setActiveGroup_DeviceTab("device")}>
                                개별 상태/제어
                            </Style.TabUnFocus>
                        )}
                    </>

                    </Style.TabFrame>
                )}
                {/* ✅ 그룹, 디바이스 탭 끝 */}


                {/* ✅ 각 메뉴 */}
                <Style.MenuArea>
                    {!selectedSiteId || !selectedGroupId ? (
                        <>
                        </>
                    ) : activeGroup_DeviceTab === "group" ? (
                    <GroupSettings
                        onfetchDeviceInfo={fetchDeviceInfo}

                        // user 정보
                        currentUser={user}
                        devices={devices}
                        // 탭 위치
                        groupSettingTab={groupSettingTab}
                        setGroupSettingTab={setGroupSettingTab}
                        // site id, group id
                        selectedSiteId={selectedSiteId}
                        selectedGroupId={selectedGroupId}
                        // Tab 1
                        brightness={brightness}
                        setBrightness={setBrightness}
                        brightnessMode={brightnessMode}
                        setBrightnessMode={setBrightnessMode}
                        // Tab 2
                        // 설정 값 없음
                        // Tab 3
                        distanceLeft={distanceLeft}
                        setDistanceLeft={setDistanceLeft}
                        distanceRight={distanceRight}
                        setDistanceRight={setDistanceRight}
                        distanceBottom={distanceBottom}
                        setDistanceBottom={setDistanceBottom}
                        // Tab 4
                        led_mode={led_mode}
                        setLed_mode={setLed_mode}
                        maxBright={maxBright}
                        setMaxBright={setMaxBright}
                        minBright={minBright}
                        setMinBright={setMinBright}
                        keepOnTime={keepOnTime}
                        setKeepOnTime={setKeepOnTime}
                        sideOnLed={sideOnLed}
                        setSideOnLed={setSideOnLed}
                        // Tab 5
                        activeMonthTab={activeMonthTab}
                        setActiveMonthTab={setActiveMonthTab}
                        nowMonth={nowMonth}
                        setnowMonth={setnowMonth}
                        mValues={mValues}
                        setMValues={setMValues}
                        />
                    ) : activeGroup_DeviceTab === "device" ? (
                    <DeviceSettings
                        // user 정보
                        currentUser={user}
                        devices={devices}
                        currentIndex={currentIndex}
                        setCurrentIndex={setCurrentIndex}
                        nextDevice={nextDevice}
                        prevDevice={prevDevice}
                        selectedSiteId={selectedSiteId}
                        selectedGroupId={selectedGroupId}
                        selectedGroupName={selectedGroupName}

                        deviceSettingTab={deviceSettingTab}
                        setDeviceSettingTab={setDeviceSettingTab}

                        // 디바이스 탭 제어 1 탭 설정 값
                        this_brightness={this_brightness}
                        setThisBrightness={setThisBrightness}
                        this_brightnessMode={this_brightnessMode}
                        setThisBrightnessMode={setThisBrightnessMode}

                        // 디바이스 탭 제어 2 탭 설정 값 없음

                        // 디바이스 탭 제어 3 탭 설정 값
                        this_distanceLeft={this_distanceLeft}
                        setThisDistanceLeft={setThisDistanceLeft}
                        this_distanceRight={this_distanceRight}
                        setThisDistanceRight={setThisDistanceRight}
                        this_distanceBottom={this_distanceBottom}
                        setThisDistanceBottom={setThisDistanceBottom}

                        // 디바이스 탭 제어 4 탭 설정 값
                        led_mode={led_mode}
                        setLed_mode={setLed_mode}
                        maxBright={maxBright}
                        setMaxBright={setMaxBright}
                        minBright={minBright}
                        setMinBright={setMinBright}
                        keepOnTime={keepOnTime}
                        setKeepOnTime={setKeepOnTime}
                        sideOnLed={sideOnLed}
                        setSideOnLed={setSideOnLed}

                        // 그래프
                        tempData={tempData}
                        setTempData={setTempData}
                        humidData={humidData}
                        setHumidData={setHumidData}
                        />
                    ) : (
                    <GroupStatus
                        // user 정보
                        currentUser={user}
                        devices={devices}
                        selectedSiteId={selectedSiteId}
                        selectedGroupId={selectedGroupId}
                        selectedGroupName={selectedGroupName}

                        />                        
                    )}
                </Style.MenuArea>
                {/* ✅ 각 메뉴 끝 */}

                <>
                {/* 👇 계정 프로필 모달 컴포넌트 렌더링 */}
                {isUserInfoModalOpen && (
                    <UserInfoDrawer
                        isOpen={isUserInfoModalOpen}
                        currentUser={user}
                        onClose={closeUserInfoModal}
                    />
                )}
                </>

            </Style.BackgroundArea>
        </MediaQuery>
    </>
    );
};

const Main: React.FC = () => (
    <SocketProvider>
        <MainContent />
    </SocketProvider>
);

export default Main;
